import React from 'react';
import { Button as MUIButton, Typography, CircularProgress } from '@mui/material';

interface ButtonProps {
  text: string;
  onClick?: (e?: any) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
  startIcon?: React.ReactNode;
  isLoading?: boolean;
}

const Button = ({
  text,
  onClick,
  disabled,
  fullWidth = true,
  variant = 'contained',
  startIcon,
  isLoading = false,
}: ButtonProps) => {
  return (
    <MUIButton
      onClick={onClick}
      disabled={disabled || isLoading}
      type="submit"
      color="primary"
      fullWidth={fullWidth}
      variant={variant}
      startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : startIcon}
      sx={(theme) => ({
        height: { xs: '28px', sm: '30px', md: '45px' },
        px: { xs: 1, sm: 2 },
        borderRadius: '8px',
        textTransform: 'none',
        fontWeight: 700,
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
          boxShadow: 'none',
          color: theme.palette.primary.contrastText,
        },
      })}
    >
      <Typography variant="body2">{text}</Typography>
    </MUIButton>
  );
};

export default Button;
